/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BorrowerGuaranteeDto
 */
export interface BorrowerGuaranteeDto {
    /**
     * 
     * @type {string}
     * @memberof BorrowerGuaranteeDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BorrowerGuaranteeDto
     */
    label: string;
    /**
     * 
     * @type {number}
     * @memberof BorrowerGuaranteeDto
     */
    deductible: number;
}

/**
 * Check if a given object implements the BorrowerGuaranteeDto interface.
 */
export function instanceOfBorrowerGuaranteeDto(value: object): value is BorrowerGuaranteeDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('deductible' in value) || value['deductible'] === undefined) return false;
    return true;
}

export function BorrowerGuaranteeDtoFromJSON(json: any): BorrowerGuaranteeDto {
    return BorrowerGuaranteeDtoFromJSONTyped(json, false);
}

export function BorrowerGuaranteeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BorrowerGuaranteeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': json['label'],
        'deductible': json['deductible'],
    };
}

export function BorrowerGuaranteeDtoToJSON(json: any): BorrowerGuaranteeDto {
    return BorrowerGuaranteeDtoToJSONTyped(json, false);
}

export function BorrowerGuaranteeDtoToJSONTyped(value?: BorrowerGuaranteeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'label': value['label'],
        'deductible': value['deductible'],
    };
}

